import magnify from 'magnify'; //eslint-disable-line
import PinchZoom from 'pinch-zoom-js';

const zoomItems = document.querySelectorAll('.js-pinch-item');

const IS_TOUCH_DEVICE =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  window.matchMedia('(pointer:coarse)').matches;

const init = () => {
  if (zoomItems.length === 0) return;

  if (IS_TOUCH_DEVICE) {
    zoomItems.forEach(item => {
      let pz = new PinchZoom(item, {
        draggableUnzoomed: false
      });

      pz.enable();
    });
  } else {
    $(document).ready(function () {
      $('.js-zoom-item').magnify();
    });
  }
};

export default init;
